import Vue from "vue"
import Vuex from "vuex"
import assessments from "./modules/assessments"
import badges from "./modules/badges"
import budgets from "./modules/budgets"
import courses from "./modules/courses"
import learningItems from "./modules/learningItems"
import users from "./modules/users"
import globals from "./modules/globals"
import documents from "./modules/documents"
import systemMessages from "./modules/systemMessages"
import notifications from "./modules/notifications"
import nudges from "./modules/nudges"
import tools from "./modules/tools"

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== "production"

export default new Vuex.Store({
  modules: {
    assessments,
    badges,
    budgets,
    courses,
    learningItems,
    globals,
    users,
    documents,
    systemMessages,
    notifications,
    nudges,
    tools
  },
  actions: {
    clearAll({ commit }) {
      commit("assessments/reset")
      commit("badges/reset")
      commit("budgets/reset")
      commit("courses/reset")
      commit("learningItems/reset")
      commit("globals/reset")
      commit("users/reset")
      commit("documents/reset")
      commit("systemMessages/reset")
      commit("notifications/reset")
      commit("nudges/reset")
      commit("tools/reset")
    }
  },
  strict: debug
})
